import { Component, computed, input, model, output, signal } from '@angular/core';
import { InlineButtonComponent } from '../../../../atoms/inline-button/inline-button.component';
import { DropdownOption } from '../../../../molecules/dropdown/dropdown.component';

@Component({
  selector: 'joii-date-picker-months',
  imports: [InlineButtonComponent],
  template: `
    <div class="month-rows">
      @for (i of months(); track i.value) {
        <button
          joii-inline-button
          [variant]="'secondary'"
          [borderless]="i.value !== (month()?.value ?? 0)"
          [transparent]="i.value !== (month()?.value ?? 0)"
          [active]="i.value === (month()?.value ?? 0)"
          (click)="selectMonth(i)"
        >
          {{ i.name }}
        </button>
      }
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      padding-top: 12px;
      min-height: 292px;
    }
    .month-rows {
      padding-top: 12px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 6px;
      margin-top: 4px;
    }
  `,
})
export class DatePickerMonthsComponent {
  months = input<DropdownOption<number>[]>([]);
  month = model.required<DropdownOption<number> | undefined>();
  monthSelection = output<DropdownOption<number> | undefined>();
  maxColumns = signal(3);

  monthRows = computed(() => {
    const rows = [];
    for (let i = 0; i < this.months().length; i += this.maxColumns()) {
      rows.push(this.months().slice(i, i + this.maxColumns()));
    }
    return rows;
  });

  selectMonth(month: DropdownOption<number>): void {
    this.month.set(month);
    this.monthSelection.emit(month);
  }
}
